import React from "react";

function CheckmarkLoader() {
  return (
    <div className="wrapper">
      <div className="circle">
        <div className="checkMark"></div>
      </div>
    </div>
  );
}

export default CheckmarkLoader;

// CSS styles
const styles = `
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 70vh;
  }
  
  .circle {
    position: relative;
    border:2px solid #00b01d;
    border-radius: 100%;
    height: 120px;
    width: 120px;
  }
  
  .checkMark {
    position: absolute;
    transform: rotate(50deg) translate(-50%, -50%);
    left: 27%;
    top: 43%;
    height: 60px;
    width: 25px;
    border-bottom: 5px solid #00b01d;
    border-right: 5px solid #00b01d;
  }
`;

// Create a style element and append it to the document's head
const styleElement = document.createElement("style");
styleElement.appendChild(document.createTextNode(styles));
document.head.appendChild(styleElement);
